// Format a number as British Pounds currency
export const formatCurrency = (amount, showSymbol = true) => {
  if (amount === undefined || amount === null) return 'N/A';
  const formatted = Number(amount).toLocaleString('en-GB', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return showSymbol ? `£${formatted}` : formatted;
};

// Format a number as a percentage
export const formatPercentage = (value, total) => {
  if (!total) return '0%';
  return `${Math.round((value / total) * 100)}%`;
};

// Format a date — supports optional custom format string and UTC flag
export const formatDate = (date, format = 'DD/MM/YYYY', useUTC = false) => {
  if (!date) return '';
  const d = new Date(date);
  if (isNaN(d.getTime())) return '';

  const day = String(useUTC ? d.getUTCDate() : d.getDate()).padStart(2, '0');
  const month = String((useUTC ? d.getUTCMonth() : d.getMonth()) + 1).padStart(2, '0');
  const year = useUTC ? d.getUTCFullYear() : d.getFullYear();

  return format.replace('DD', day).replace('MM', month).replace('YYYY', year);
};

// Format a date with time
export const formatDateTime = (datetime, locale = 'en-GB') => {
  if (!datetime) return '';
  return new Date(datetime).toLocaleString(locale, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

// Format a UK phone number (11 digits starting with 0 → 01234 567890)
export const formatPhoneNumber = (phone) => {
  if (!phone) return '';
  const cleaned = phone.replace(/\D/g, '');
  if (cleaned.startsWith('0') && cleaned.length === 11) {
    return cleaned.replace(/(\d{5})(\d{6})/, '$1 $2');
  }
  return phone;
};

// Capitalise the first letter of each word
export const capitalize = (str) => {
  if (!str) return '';
  return str
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

// Format bytes to a human-readable size
export const formatFileSize = (bytes, decimals = 2) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(decimals < 0 ? 0 : decimals))} ${sizes[i]}`;
};

// Truncate a string to a given length
export const truncateString = (str, length = 50) => {
  if (!str) return '';
  if (str.length <= length) return str;
  return `${str.slice(0, length)}...`;
};

// Generate a random reference number
export const generateReference = (prefix = 'EXP') => {
  const timestamp = Date.now().toString().slice(-6);
  const random = Math.floor(Math.random() * 1000).toString().padStart(3, '0');
  return `${prefix}${timestamp}${random}`;
};
